import * as React from 'react';

import { configAnalytics, navigation } from '@origin-digital/reporting-client';
import { ExperienceProvider, ExperienceSelector } from '@origin-digital/features';
import { OriginThemeProvider } from '@origin-digital/ods-core';
import { Interstitial } from '@origin-digital/personalisation';

import { CONFIG } from './consts/mediaQuery.js';
import { mboxes } from './consts/mboxes';
import { MediaQueryProvider } from 'react-media-query-hoc';
import { PageContent } from './components/PageContent/PageContent';

export const appName = 'origin-homepage';

// Workaround for below error
// Its instance type 'Interstitial' is not a valid JSX element.
// Type 'Interstitial' is missing the following properties from type
// 'ElementClass': context, setState, forceUpdate, props, refs
const SafelyTypedInterstitial = Interstitial as any;

export class App extends React.Component {
  public componentDidMount() {
    configAnalytics({ appName });
    navigation('screen', {
      appName,
      currentUri: window.location.href,
      friendlyUri: 'originenergy:for-home',
    });
  }

  public render() {
    return (
      <OriginThemeProvider generatorClassNameOptions={{ seed: 'homepage' }}>
        <ExperienceProvider mboxes={Object.values(mboxes)}>
          <MediaQueryProvider queries={CONFIG}>
            <PageContent />
          </MediaQueryProvider>
          <ExperienceSelector mbox={mboxes.interstitialMbox}>
            {(content) => <SafelyTypedInterstitial content={content} />}
          </ExperienceSelector>
        </ExperienceProvider>
      </OriginThemeProvider>
    );
  }
}
